/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON, FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON, } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentType';
import { FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON, FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON, } from './FxIdDomainEntitiesDocumentsGameDocumentVersion';
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument(value) {
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    if (!('DocumentType' in value) || value['DocumentType'] === undefined)
        return false;
    if (!('CreatedAt' in value) || value['CreatedAt'] === undefined)
        return false;
    if (!('IsActive' in value) || value['IsActive'] === undefined)
        return false;
    if (!('GameSystemName' in value) || value['GameSystemName'] === undefined)
        return false;
    if (!('Versions' in value) || value['Versions'] === undefined)
        return false;
    if (!('WebDocumentUrl' in value) || value['WebDocumentUrl'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Id': json['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeFromJSON(json['DocumentType']),
        'CreatedAt': (new Date(json['CreatedAt'])),
        'IsActive': json['IsActive'],
        'GameSystemName': json['GameSystemName'],
        'Versions': (json['Versions'].map(FxIdDomainEntitiesDocumentsGameDocumentVersionFromJSON)),
        'AcceptDocumentUrl': json['AcceptDocumentUrl'] == null ? undefined : json['AcceptDocumentUrl'],
        'WebDocumentUrl': json['WebDocumentUrl'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Id': value['Id'],
        'DocumentType': FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocumentDocumentTypeToJSON(value['DocumentType']),
        'CreatedAt': ((value['CreatedAt']).toISOString()),
        'IsActive': value['IsActive'],
        'GameSystemName': value['GameSystemName'],
        'Versions': (value['Versions'].map(FxIdDomainEntitiesDocumentsGameDocumentVersionToJSON)),
        'AcceptDocumentUrl': value['AcceptDocumentUrl'],
        'WebDocumentUrl': value['WebDocumentUrl'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureDocument.js.map